import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { RIValidationIndicacionContent } from './components/RIValidationIndicacionContent';

export default function RIValidationIndicacion() {
    return (
        <>
            <MainContent
                component={<RIValidationIndicacionContent />}
                titulo='Ingreso de indicación'
                noBackground
                tableMaxWidth
            />
        </>
    );

};